import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./lib/i18n";
import "./App.css";

import Landing from "./pages/Landing";
import Wizard from "./pages/Wizard";
import Success from "./pages/Success";
import Cancelled from "./pages/Cancelled";
import TrackOrder from "./pages/TrackOrder";
import UploadPhotos from "./pages/UploadPhotos";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminOrderDetail from "./pages/admin/AdminOrderDetail";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminAnalytics from "./pages/admin/AdminAnalytics";
import PolicyPage from "./pages/PolicyPage";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/create" element={<Wizard />} />
            <Route path="/comprar" element={<Wizard />} />
            <Route path="/order/success" element={<Success />} />
            <Route path="/order/cancelled" element={<Cancelled />} />
            <Route path="/track/:token" element={<TrackOrder />} />
            <Route path="/order/:token/photos" element={<UploadPhotos />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/orders/:id" element={<AdminOrderDetail />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
            <Route path="/admin/analytics" element={<AdminAnalytics />} />
            <Route path="/privacy-policy" element={<PolicyPage slug="privacy-policy" />} />
            <Route path="/terms" element={<PolicyPage slug="terms" />} />
            <Route path="/shipping-policy" element={<PolicyPage slug="shipping-policy" />} />
            <Route path="/returns-refunds" element={<PolicyPage slug="returns-refunds" />} />
            <Route path="/contact" element={<PolicyPage slug="contact" />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
